import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { EnderecoCep } from '../models/endereco-cep';
import { UsuarioProvider } from '../providers/usuario.provider';
import { Util } from '../utils/util';

@Injectable({
    providedIn: 'root'
})
export class EnderecoService {

    constructor(
        private http: HttpClient,
        private usuarioProvider: UsuarioProvider
    ) {
    }

    async listarUf(utilizarEsfera = true, codigoUf = undefined) {
        if (utilizarEsfera) {
            const usuario: any = await this.usuarioProvider.getUsuario();
            const splitEsferaAtuacao: Array<string> = usuario.esfera.esferaAtuacao.split('/');
            codigoUf = splitEsferaAtuacao.length >= 2 ? splitEsferaAtuacao[1] : undefined;
            console.log(splitEsferaAtuacao, codigoUf);
        }
        let url = environment.urlBaseNova + '/corporativo/uf';
        if (codigoUf && codigoUf !== 'undefined') {
            url = url + '?codigo-uf=' + codigoUf;
        }
        return await this.http.get<any>(url).toPromise();
    }

    async ufBySiglaUnidade(uf: string) {
        const url = '/corporativo/uf/sigla/' + uf;
        return await this.http.get<any>(environment.urlBaseNova + url).toPromise();
    }

    async ufByCodigoIbge(codigo: string) {
        return await this.http.get(environment.urlBaseNova + '/corporativo/uf/' + codigo).toPromise();
    }

    async municipioByCodigoIbge(codigo: any) {
        return await this.http.get(environment.urlBaseNova + '/corporativo/municipios/' + codigo).toPromise();
    }

    async listarMunicipio(filtro?: any) {
        const usuario: any = await this.usuarioProvider.getUsuario();
        const splitEsferaAtuacao: Array<string> = usuario.esfera.esferaAtuacao.split('/');
        const codigoUf = splitEsferaAtuacao.length >= 2 ? splitEsferaAtuacao[1] : undefined;
        const codigoMunicipioIbge = splitEsferaAtuacao.length >= 3 && usuario.perfil.sigla !== 'ADS' ? splitEsferaAtuacao[2] : undefined;
        filtro.codigoUf = codigoUf ? codigoUf : filtro.codigoUf;
        filtro.codigoMunicipioIbge = codigoMunicipioIbge ? codigoMunicipioIbge : filtro.codigoMunicipioIbge;
        let url = '/corporativo/municipios/filtro';
        if (filtro.codigoMunicipioIbge !== undefined && !filtro.ignoreEsferas) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-municipio-ibge=' + filtro.codigoMunicipioIbge;
        }
        if (filtro.codigoRegionalSaude !== undefined) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-regional-saude=' + filtro.codigoRegionalSaude;
        }
        if (filtro.codigoUf !== undefined && !filtro.ignoreEsferas) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-uf=' + filtro.codigoUf;
        }
        if (filtro.nome !== undefined) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'nome=' + filtro.nome;
        }
        if (filtro.siglaUf !== undefined) {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'sigla-uf=' + filtro.siglaUf;
        }
        return await this.http.get<any>(environment.urlBaseNova + url).toPromise();
    }

    async listarRegiao(siglaUf = null) {
        const regioes: any = await this.http.get('./assets/dados-fake/cidades.json').toPromise();
        if (siglaUf) {
            return regioes.filter(m => m.siglaUf === siglaUf);
        } else {
            return regioes;
        }
    }

    async listarEstabelecimento(siglaUf = null) {
        const estabelecimentos: any = await this.http.get('./assets/dados-fake/cidades.json').toPromise();
        if (siglaUf) {
            return estabelecimentos.filter(m => m.siglaUf === siglaUf);
        } else {
            return estabelecimentos;
        }
    }

    async buscarPorCep(cep): Promise<EnderecoCep> {
        const usuario: any = await this.usuarioProvider.getUsuario();
        const splitEsferaAtuacao: Array<string> = usuario.esfera.esferaAtuacao.split('/');
        const codigoUf = splitEsferaAtuacao.length >= 2 ? splitEsferaAtuacao[1] : undefined;
        const codigoMunicipioIbge = splitEsferaAtuacao.length >= 3 && usuario.perfil.sigla !== 'ARS' ? splitEsferaAtuacao[2] : undefined;
        const codigoRegionalSaude = splitEsferaAtuacao.length >= 3 && usuario.perfil.sigla === 'ARS' ? splitEsferaAtuacao[2] : undefined;
        console.log(codigoUf,codigoMunicipioIbge,codigoRegionalSaude)
        let url = `/corporativo/enderecos/${Util.removerNotDigit(cep)}`;
        if (codigoUf && codigoUf !== 'undefined') {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-uf=' + codigoUf;
        }
        if (codigoMunicipioIbge && codigoMunicipioIbge !== 'undefined') {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-municipio-ibge=' + codigoMunicipioIbge;
        }
        if (codigoRegionalSaude && codigoRegionalSaude !== 'undefined') {
            url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'codigo-regional-saude=' + codigoRegionalSaude;
        }
        return await this.http.get<any>(environment.urlBaseNova + url).toPromise();
    }

    async buscarMunicipio(codigoIbge: number | string) {
        const url = `/corporativo/municipios/${codigoIbge}`;
        return this.http.get<any>(environment.urlBaseNova + url).toPromise();
    }

    async buscarPaginado(pageNumber: any = 0, pageSize: any = 5, filtro?: any): Promise<EnderecoCep> {
        let url = '/corporativo/enderecos?pagina=' + pageNumber + '&tamanho-pagina=' + pageSize;
        if (filtro.codigoMunicipioIbge !== undefined) {
            url = url + '&codigo-municipio-ibge=' + filtro.codigoMunicipioIbge;
        }
        if (filtro.codigoRegionalSaude !== undefined) {
            url = url + '&codigo-regional-saude=' + filtro.codigoRegionalSaude;
        }
        if (filtro.codigoUf !== undefined) {
            url = url + '&codigo-uf=' + filtro.codigoUf;
        }
        const response = await this.http.get<any>(environment.urlBaseNova + url).toPromise();
        return new EnderecoCep(response.record);
    }

    async buscarMunicipioPorUf(sigla: string) {
        const url = `/corporativo/municipios/siglauf/${sigla}`;
        return  await this.http.get<any>(environment.urlBaseNova + url).toPromise();
    }

}
